export const DRAWER_WIDTH_PX = 604;
export const DRAWER_UPLOAD_ONLY_WIDTH_PX = 370;
export const LIST_WIDTH_PX = 292;
